import axios from "common/helpers/axios.helper"

export function setSettingList(settings) {
    return {
        type: "SET_SETTING_LIST",
        payload: settings
    }
}

export function setTagSettings(tagSettings) {
    return {
        type: "SET_TAG_SETTINGS",
        payload: tagSettings
    }
}

export function setTagSettingsCurrent(tagSettingsCurrent) {
    return {
        type: "SET_TAG_SETTINGS_CURRENT",
        payload: tagSettingsCurrent
    }
}

export const getSettingList = () => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'SETTING_LIST_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/settings/${currentContainer}`),
            method: 'GET',
            responseType: 'json',
            headers: { 'authorization': token, 'Content-Type': 'application/json' }
        }).then((response) => {
            dispatch({ type: 'SETTING_LIST_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_TAG_SETTINGS', payload: response.data.tags });
        }).catch((error) => {
            dispatch({ type: 'SETTING_LIST_ERROR', payload: error.response });
        });
    }
}

export const getSetting = (id, modalDialog = null, modalType = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'SETTING_SELECT_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/settings/${currentContainer}/id/${id}`),
            method: 'GET',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'SETTING_SELECT_SUCCESS', payload: response.data });
            if (modalDialog) {
                dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: modalType } });
            }
        }).catch((error) => {
            dispatch({ type: 'SETTING_SELECT_ERROR', payload: error.response })
        });
    }
}

export const updateSetting = (id, data) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'SETTING_UPDATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/settings/${currentContainer}/id/${id}`),
            method: 'PATCH',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'SETTING_UPDATE_SUCCESS', payload: response.data });
            dispatch(getSettingList())
        }).catch((error) => {
            dispatch({ type: 'SETTING_UPDATE_ERROR', payload: error.response });
        });
    }
}
